import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=03a8814c"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme3DesktopNavBar: require('/app/components/Theme3/Desktop/NavBar.vue').default,Theme3MobileNavBar: require('/app/components/Theme3/Mobile/NavBar.vue').default})
